





































































































import Vue from 'vue'
import { GET_CURRENT_USER_ID, GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import { DxColumn, DxDataGrid, DxScrolling } from 'devextreme-vue/data-grid'
import {
  FETCH_ADDRESS_GROUP,
  FETCH_COUNTRIES_LIST,
  FETCH_SEARCH_ADDRESS_LIST
} from '@/store/action-types'
import { ProjectAddressSearchRequestPayload } from '@/types/payload'
import { SearchAddress } from '@/model/addresses/SearchAddress'
import { GetCountriesResponse, ProjectAddressSearchResponse } from '@/types/service-response'
import { AddressGroup } from '@/model/addresses/AddressGroup'
import { AddressCountry } from '@/model/addresses/AddressCountry'

interface ComponentData {
  loading: boolean
  landList: AddressCountry[]
  addressGroupList: AddressGroup[]
  sortierung: string
  name: string
  vorname: string
  ort: string
  plz: string
  strasse: string
  hausnummer: string
  region: string
  land: AddressCountry | undefined
  adressgruppe: string
  telefonprivate: string
  telefongeschaftlich: string
  handyprivat: string
  handygeschaeftlich: string
  mailprivat: string
  mailgeschaftlich: string
  maxRecords: number
  addressList: SearchAddress[]
  focusedRowKey: number
}

export default Vue.extend({
  name: 'ProjectAddressSearch',

  components: {
    DxDataGrid,
    DxColumn,
    DxScrolling
  },

  props: {
    show: {
      type: Boolean,
      default: false
    }
  },

  data (): ComponentData {
    return {
      loading: false,
      landList: [],
      addressGroupList: [],
      sortierung: '',
      name: '',
      vorname: '',
      ort: '',
      plz: '',
      strasse: '',
      hausnummer: '',
      region: '',
      land: undefined,
      adressgruppe: '',
      telefonprivate: '',
      telefongeschaftlich: '',
      handyprivat: '',
      handygeschaeftlich: '',
      mailprivat: '',
      mailgeschaftlich: '',
      maxRecords: 500,
      addressList: [],
      focusedRowKey: -1,
    }
  },

  computed: {
    currentUserId (): number {
      return this.$store.getters[GET_CURRENT_USER_ID]
    },

    selectedLanguageId (): number {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].syzId
    },
  },

  methods: {
    onCloseButtonClick (): void {
      this.$emit('close')
    },

    onCancelButtonClick (): void {
      this.$emit('close')
    },

    onKeyDown (e: any): void {
      if(e.event.key === "Enter") {
        const foundAddress: SearchAddress | undefined = this.addressList.find((item: SearchAddress) => item.id === this.focusedRowKey)
        if(foundAddress) {
          this.$emit('selectedAddress', foundAddress)
        }
      }
    },

    rowDblClick(event: any): void {
      this.$emit('selectedAddress', event.data)
    },

    onSearchButtonClick (): void {
      this.searchAddress()
    },

    onFocusedCellChanging (e: any) {
      e.isHighlighted = false
    },

    onFocusedRowChanged (e: any): void {
      this.focusedRowKey = e.component.option('focusedRowKey')
    },

    async searchAddress (): Promise<void> {
      const payload: ProjectAddressSearchRequestPayload = {
        Sortierung: this.sortierung,
        Adressgruppe: this.adressgruppe ? this.adressgruppe : '',
        Name: this.name,
        Region: this.region,
        Vorname: this.vorname,
        Land: this.land ? this.land.name : '',
        Ort: this.ort,
        Handyprivat: this.handyprivat,
        Handygeschaeftlich: this.handygeschaeftlich,
        Telefonprivat: this.telefonprivate,
        Telefongeschaeftlich: this.telefongeschaftlich,
        AdressZusatzfelderSearchItems: [],
        PLZ: this.plz,
        Mailprivat: this.mailprivat,
        Strasse: this.strasse,
        Hausnummer: this.hausnummer,
        Mailgeschaeftlich: this.mailgeschaftlich,
        Sprache: this.selectedLanguageId,
        Mitarbeiter: this.currentUserId,
        MaxRecords: this.maxRecords,
        Aktiv: true,
        Passiv: false,
        Alle: false
      }

      try {
        this.loading = true
        const response: ProjectAddressSearchResponse = await this.$store.dispatch(FETCH_SEARCH_ADDRESS_LIST, payload)
        if(!response.IsError) {
          this.addressList = SearchAddress.createFromResponse(response.Results)

          if(this.addressList.length > 0) {
            //@ts-ignore
            this.$refs.dataGrid.instance.option("focusedRowIndex", -1);

            this.focusedRowKey = 0
            setTimeout(() => {
              //@ts-ignore
              this.$refs.dataGrid.instance.focus()
              this.focusedRowKey = this.addressList[0].id
            }, 100)
          }
        }
        this.loading = false
      } catch {
        this.loading = false
      }
    }
  },

  async mounted (): Promise<void> {
    setTimeout(() => {
      const sortierungField: any = this.$refs['sortierung']
      if (sortierungField) {
        sortierungField.focus()
      }
    })
    const response: GetCountriesResponse = await this.$store.dispatch(FETCH_COUNTRIES_LIST)
    this.landList = !response.IsError ? AddressCountry.createFromResponse(response.Countries) : []
    this.addressGroupList = await this.$store.dispatch(FETCH_ADDRESS_GROUP)
  }
})
